import React from 'react';

const manufacturers = [
  { name: 'DJI', logo: 'DJI' },
  { name: 'Parrot', logo: 'PARROT' },
  { name: 'Autel', logo: 'AUTEL' },
  { name: 'Skydio', logo: 'SKYDIO' },
  { name: 'Freefly', logo: 'FREEFLY' },
  { name: 'Wingtra', logo: 'WINGTRA' },
  { name: 'senseFly', logo: 'SENSEFLY' },
  { name: 'Yuneec', logo: 'YUNEEC' },
];

export default function ManufacturerLogos() {
  return (
    <div className="w-full bg-muted/30 border-b border-border py-3">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center gap-6 sm:gap-10 flex-wrap">
          <span className="text-xs text-muted-foreground uppercase tracking-wider font-medium hidden sm:block">
            Trusted Brands
          </span>
          <div className="flex items-center gap-6 sm:gap-10 flex-wrap justify-center">
            {manufacturers.map((manufacturer) => (
              <span
                key={manufacturer.name}
                className="text-xs sm:text-sm font-bold tracking-widest text-muted-foreground/60 hover:text-muted-foreground/80 transition-colors cursor-default"
                title={manufacturer.name}
              >
                {manufacturer.logo}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
